import {
  collectionGroup,
  collection,
  doc,
  getDocs,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";

import { db } from "../../../backend/firebaseConfig";

const STAFF_ROOT_PATH = ["Authorized Members", "Staff", "Data"];

const normalizeEmail = (email = "") => String(email).trim().toLowerCase();

const normalizeDepartments = (departments) => {
  if (!Array.isArray(departments)) return [];

  return departments
    .map((department) => {
      if (typeof department === "string") {
        const value = department.trim();

        return value
          ? {
              id: value,
              name: value,
            }
          : null;
      }

      if (department && typeof department === "object") {
        const id = String(
          department.id ||
            department.departmentId ||
            department.value ||
            department.name ||
            department.label ||
            "",
        ).trim();

        const name = String(
          department.name ||
            department.departmentName ||
            department.label ||
            id,
        ).trim();

        return id
          ? {
              id,
              name: name || id,
            }
          : null;
      }

      return null;
    })
    .filter(Boolean);
};

const toDateKey = (value) => {
  if (!value) return "";

  if (typeof value === "string") {
    return value.slice(0, 10);
  }

  if (value?.toDate) {
    const date = value.toDate();
    return date.toISOString().slice(0, 10);
  }

  if (value instanceof Date) {
    return value.toISOString().slice(0, 10);
  }

  return "";
};

const getStaffDisplayName = (staffData = {}, staffEmail = "") => {
  const fullName = String(
    staffData.staffName ||
      staffData.displayName ||
      staffData.name ||
      `${staffData.firstName || ""} ${staffData.lastName || ""}`,
  ).trim();

  return fullName || staffEmail;
};

const isDateInYear = (dateKey, year) => {
  return String(dateKey || "").startsWith(`${year}-`);
};

export const normalizeStaffEmail = (email = "") => {
  return String(email || "")
    .trim()
    .toLowerCase();
};

const mapHolidayCollectionGroupDoc = (docSnap) => {
  const data = docSnap.data() || {};
  const pathParts = docSnap.ref.path.split("/");

  const dataIndex = pathParts.indexOf("Data");
  const emailFromPath =
    dataIndex >= 0 && pathParts[dataIndex + 1] ? pathParts[dataIndex + 1] : "";

  const ownerStaffEmail = normalizeStaffEmail(
    data.staffEmail || data.ownerStaffEmail || emailFromPath,
  );

  return {
    id: docSnap.id,
    ownerStaffEmail,
    staffEmail: normalizeStaffEmail(data.staffEmail || ownerStaffEmail),
    ...data,
  };
};

export const subscribeHolidayBalancesForYear = ({ year, onData, onError }) => {
  if (!year) return () => {};

  const selectedYear = String(year);

  return onSnapshot(
    collectionGroup(db, "LeaveBalances"),
    (snapshot) => {
      const items = snapshot.docs
        .map(mapHolidayCollectionGroupDoc)
        .filter((item) => {
          return (
            String(item.id) === selectedYear ||
            String(item.year) === selectedYear
          );
        });

      // console.log("[staffHolidayFirebase] balances snapshot", {
      //   year: selectedYear,
      //   count: items.length,
      //   items,
      // });

      onData(items);
    },
    onError,
  );
};
const getStaffEmailFromCollectionGroupDoc = (docSnap) => {
  const data = docSnap.data() || {};

  if (data.staffEmail) {
    return normalizeStaffEmail(data.staffEmail);
  }

  if (data.ownerStaffEmail) {
    return normalizeStaffEmail(data.ownerStaffEmail);
  }

  const pathParts = docSnap.ref.path.split("/");

  const dataIndex = pathParts.indexOf("Data");

  if (dataIndex >= 0 && pathParts[dataIndex + 1]) {
    return normalizeStaffEmail(pathParts[dataIndex + 1]);
  }

  return "";
};

const mapCollectionGroupDoc = (docSnap) => {
  const data = docSnap.data() || {};
  const ownerStaffEmail = getStaffEmailFromCollectionGroupDoc(docSnap);

  return {
    id: docSnap.id,
    ownerStaffEmail,
    staffEmail: normalizeStaffEmail(data.staffEmail || ownerStaffEmail),
    ...data,
  };
};

const STAFF_HOLIDAY_API_BASE_URL =
  process.env.REACT_APP_SERVER_URL ||
  // process.env.REACT_APP_API_BASE_URL ||
  "https://rosemountstaffserver.onrender.com" ||
  "http://localhost:5000" ||
  "http://localhost:3000";
const API_BASE_URL = STAFF_HOLIDAY_API_BASE_URL.replace(/\/$/, "");

const buildHolidayApiUrl = (path) => {
  return `${API_BASE_URL}/api/staff-holidays${path}`;
};

const isFirestoreIndexError = (error) => {
  const message = String(error?.message || "");

  return (
    message.includes("requires an index") ||
    message.includes("requires a COLLECTION_GROUP_ASC index") ||
    message.includes("requires a COLLECTION_GROUP_DESC index") ||
    message.includes("index is not ready") ||
    message.includes("That index is not ready yet") ||
    message.includes("firestoreindexes")
  );
};

// const postStaffHolidayApi = async (path, payload = {}) => {
//   const response = await fetch(
//     `${STAFF_HOLIDAY_API_BASE_URL}/api/staff-holidays${path}`,
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(payload),
//     },
//   );

//   const data = await response.json().catch(() => ({}));

//   if (!response.ok || data.success === false) {
//     throw new Error(
//       data.message || `Staff holiday request failed: ${response.status}`,
//     );
//   }

//   return data;
// };

// export const submitStaffHolidayRequest = async (payload) => {
//   return postStaffHolidayApi("/request", payload);
// };

// export const approveStaffHolidayAsHolidayManager = async ({
//   staffEmail,
//   requestId,
//   holidayManagerEmail,
// }) => {
//   return postStaffHolidayApi("/holiday-manager-approve", {
//     staffEmail,
//     requestId,
//     holidayManagerEmail,
//   });
// };

// export const approveStaffHolidayAsAdmin = async ({
//   staffEmail,
//   requestId,
//   adminEmail,
// }) => {
//   return postStaffHolidayApi("/admin-approve", {
//     staffEmail,
//     requestId,
//     adminEmail,
//   });
// };

// export const rejectStaffHolidayRequest = async ({
//   staffEmail,
//   requestId,
//   rejectedBy,
//   rejectionReason = "",
// }) => {
//   return postStaffHolidayApi("/reject", {
//     staffEmail,
//     requestId,
//     rejectedBy,
//     rejectionReason,
//   });
// };

// Optional aliases if your components already use these names
// export const approveHolidayAsHolidayManager =
//   approveStaffHolidayAsHolidayManager;
// export const approveHolidayAsAdmin = approveStaffHolidayAsAdmin;

// export const submitStaffHolidayRequest = async (payload) => {
//   return postToHolidayApi("/request", payload);
// };

// export const approveStaffHolidayAsHolidayManager = async (payload) => {
//   return postToHolidayApi("/holiday-manager-approve", payload);
// };

// export const approveStaffHolidayAsAdmin = async (payload) => {
//   return postToHolidayApi("/admin-approve", payload);
// };

// export const rejectStaffHolidayRequest = async (payload) => {
//   return postToHolidayApi("/reject", payload);
// };

export const getStaffDocRef = (email) => {
  return doc(db, "Authorized Members", "Staff", "Data", email);
};

export const getStaffBalanceRef = (email, year) => {
  return doc(
    db,
    "Authorized Members",
    "Staff",
    "Data",
    email,
    "LeaveBalances",
    String(year),
  );
};

export const subscribeStaffHolidayProfile = ({
  staffEmail,
  onData,
  onError,
}) => {
  const staffDocRef = doc(db, ...STAFF_ROOT_PATH, normalizeEmail(staffEmail));

  return onSnapshot(
    staffDocRef,
    (snapshot) => {
      if (!snapshot.exists()) {
        onData(null);
        return;
      }

      const data = snapshot.data() || {};
      const departments = normalizeDepartments(data.departments);

      onData({
        id: snapshot.id,
        staffEmail: snapshot.id,
        ...data,
        departments,
        departmentId: departments[0]?.id || "",
        departmentName: departments[0]?.name || "",
      });
    },
    onError,
  );
};

export const subscribeStaffHolidayBalance = ({
  staffEmail,
  year,
  onData,
  onError,
}) => {
  const balanceDocRef = doc(
    db,
    ...STAFF_ROOT_PATH,
    normalizeEmail(staffEmail),
    "LeaveBalances",
    String(year),
  );

  return onSnapshot(
    balanceDocRef,
    (snapshot) => {
      onData(
        snapshot.exists()
          ? {
              id: snapshot.id,
              ...snapshot.data(),
            }
          : null,
      );
    },
    onError,
  );
};

export const subscribeMyHolidayRequests = ({ staffEmail, onData, onError }) => {
  if (!staffEmail) return () => {};

  const q = query(
    collectionGroup(db, "LeaveRequests"),
    where("staffEmail", "==", staffEmail),
    orderBy("createdAt", "desc"),
  );

  let fallbackUnsubscribe = null;

  const mapDocs = (docs) => docs.map(mapCollectionGroupDoc);

  const sortByCreatedAtDesc = (items) => {
    return [...items].sort((a, b) => {
      const left = a.createdAt?.seconds || 0;
      const right = b.createdAt?.seconds || 0;
      return right - left;
    });
  };

  const startFallbackSubscription = () => {
    if (fallbackUnsubscribe) {
      return;
    }

    // console.warn(
    //   "[staffHolidayFirebase] Falling back to unindexed my-requests query",
    //   {
    //     staffEmail,
    //   },
    // );

    fallbackUnsubscribe = onSnapshot(
      collectionGroup(db, "LeaveRequests"),
      { includeMetadataChanges: true },
      (snapshot) => {
        if (snapshot.metadata.fromCache) return;

        const mapped = mapDocs(snapshot.docs).filter(
          (item) => item.staffEmail === staffEmail,
        );

        onData(sortByCreatedAtDesc(mapped));
      },
      onError,
    );
  };

  const primaryUnsubscribe = onSnapshot(
    q,
    { includeMetadataChanges: true },
    (snapshot) => {
      if (snapshot.metadata.fromCache) return;

      onData(mapDocs(snapshot.docs));
    },
    (error) => {
      const isIndexError = isFirestoreIndexError(error);

      if (isIndexError) {
        startFallbackSubscription();
        return;
      }

      onError?.(error);
    },
  );

  return () => {
    primaryUnsubscribe?.();
    fallbackUnsubscribe?.();
  };
};

// export const cancelStaffHolidayRequest = async ({
//   staffEmail,
//   requestId,
//   cancelledBy,
//   cancellationReason = "",
// }) => {
//   return postStaffHolidayApi("/cancel", {
//     staffEmail,
//     requestId,
//     cancelledBy,
//     cancellationReason,
//   });
// };

// export const updateStaffHolidayRequest = async ({
//   staffEmail,
//   requestId,
//   leaveType,
//   startDate,
//   endDate,
//   startDayType,
//   endDayType,
//   staffNotes,
//   updatedBy,
// }) => {
//   return postStaffHolidayApi("/update", {
//     staffEmail,
//     requestId,
//     leaveType,
//     startDate,
//     endDate,
//     startDayType,
//     endDayType,
//     staffNotes,
//     updatedBy,
//   });
// };

export const subscribeManagerHolidayRequests = ({
  holidayManagerEmail,
  onData,
  onError,
}) => {
  if (!holidayManagerEmail) return () => {};

  const normalizedManagerEmail = normalizeStaffEmail(holidayManagerEmail);

  const q = query(
    collectionGroup(db, "LeaveRequests"),
    where("holidayManagerEmails", "array-contains", normalizedManagerEmail),
    orderBy("createdAt", "desc"),
  );

  let fallbackUnsubscribe = null;

  const mapDocs = (docs) =>
    docs.map((docSnap) => ({
      id: docSnap.id,
      ownerStaffEmail: docSnap.ref.parent.parent.id,
      ...docSnap.data(),
    }));

  const sortByCreatedAtDesc = (items) => {
    return [...items].sort((a, b) => {
      const left = a.createdAt?.seconds || 0;
      const right = b.createdAt?.seconds || 0;
      return right - left;
    });
  };

  const includesManagerEmail = (item = {}) => {
    const possibleFields = [
      item.holidayManagerEmails,
      item.lineholidayManagerEmails,
      item.lineManagerEmails,
    ];

    return possibleFields.some((field) => {
      if (!Array.isArray(field)) return false;

      return field
        .map((email) => normalizeStaffEmail(email))
        .includes(normalizedManagerEmail);
    });
  };

  const startFallbackSubscription = () => {
    if (fallbackUnsubscribe) {
      return;
    }

    // console.warn(
    //   "[staffHolidayFirebase] Falling back to unindexed manager-requests query",
    //   { holidayManagerEmail },
    // );

    fallbackUnsubscribe = onSnapshot(
      collectionGroup(db, "LeaveRequests"),
      { includeMetadataChanges: true },
      (snapshot) => {
        if (snapshot.metadata.fromCache) return;

        const mapped = mapDocs(snapshot.docs).filter((item) =>
          includesManagerEmail(item),
        );

        onData(sortByCreatedAtDesc(mapped));
      },
      onError,
    );
  };

  const primaryUnsubscribe = onSnapshot(
    q,
    { includeMetadataChanges: true },
    (snapshot) => {
      if (snapshot.metadata.fromCache) return;

      onData(mapDocs(snapshot.docs));
    },
    (error) => {
      const isIndexError = isFirestoreIndexError(error);

      if (isIndexError) {
        startFallbackSubscription();
        return;
      }

      onError?.(error);
    },
  );

  return () => {
    primaryUnsubscribe?.();
    fallbackUnsubscribe?.();
  };
};

export const subscribeAdminHolidayRequests = ({ onData, onError }) => {
  const q = query(
    collectionGroup(db, "LeaveRequests"),
    orderBy("createdAt", "desc"),
  );

  let fallbackUnsubscribe = null;

  const mapDocs = (docs) =>
    docs.map((docSnap) => ({
      id: docSnap.id,
      ownerStaffEmail: docSnap.ref.parent.parent.id,
      ...docSnap.data(),
    }));

  const sortByCreatedAtDesc = (items) => {
    return [...items].sort((a, b) => {
      const left = a.createdAt?.seconds || 0;
      const right = b.createdAt?.seconds || 0;
      return right - left;
    });
  };

  const startFallbackSubscription = () => {
    if (fallbackUnsubscribe) {
      return;
    }

    // console.warn(
    //   "[staffHolidayFirebase] Falling back to unindexed admin-requests query",
    // );

    fallbackUnsubscribe = onSnapshot(
      collectionGroup(db, "LeaveRequests"),
      { includeMetadataChanges: true },
      (snapshot) => {
        if (snapshot.metadata.fromCache) return;

        onData(sortByCreatedAtDesc(mapDocs(snapshot.docs)));
      },
      onError,
    );
  };

  const primaryUnsubscribe = onSnapshot(
    q,
    { includeMetadataChanges: true },
    (snapshot) => {
      if (snapshot.metadata.fromCache) return;

      onData(mapDocs(snapshot.docs));
    },
    (error) => {
      const isIndexError = isFirestoreIndexError(error);

      if (isIndexError) {
        startFallbackSubscription();
        return;
      }

      onError?.(error);
    },
  );

  return () => {
    primaryUnsubscribe?.();
    fallbackUnsubscribe?.();
  };
};

export const subscribeHolidayTrackerEvents = ({ year, onData, onError }) => {
  const staffCollectionRef = collection(db, ...STAFF_ROOT_PATH);

  const staffUnsubscribe = onSnapshot(
    staffCollectionRef,
    (staffSnapshot) => {
      const allTrackerEvents = [];
      const eventUnsubscribes = [];

      if (staffSnapshot.empty) {
        onData([]);
        return;
      }

      let loadedStaffCount = 0;

      const publishIfReady = () => {
        loadedStaffCount += 1;

        if (loadedStaffCount === staffSnapshot.docs.length) {
          onData(
            allTrackerEvents.sort((a, b) => {
              const dateCompare = String(a.date).localeCompare(String(b.date));

              if (dateCompare !== 0) return dateCompare;

              return String(a.staffName).localeCompare(String(b.staffName));
            }),
          );
        }
      };

      staffSnapshot.docs.forEach((staffDoc) => {
        const staffEmail = normalizeEmail(staffDoc.id);
        const staffData = staffDoc.data() || {};

        const departments = normalizeDepartments(staffData.departments);
        const primaryDepartment = departments[0];

        const staffName = getStaffDisplayName(staffData, staffEmail);

        const leaveEventsRef = collection(
          db,
          ...STAFF_ROOT_PATH,
          staffDoc.id,
          "LeaveEvents",
        );

        const unsubscribeLeaveEvents = onSnapshot(
          leaveEventsRef,
          (leaveEventsSnapshot) => {
            const staffEvents = [];

            leaveEventsSnapshot.docs.forEach((leaveEventDoc) => {
              const leaveEventData = leaveEventDoc.data() || {};
              const date = toDateKey(
                leaveEventData.date ||
                  leaveEventData.leaveDate ||
                  leaveEventData.startDate ||
                  leaveEventDoc.id,
              );

              if (!isDateInYear(date, year)) {
                return;
              }

              staffEvents.push({
                id: leaveEventDoc.id,
                ...leaveEventData,
                

                date,

                staffEmail,
                ownerStaffEmail: staffEmail,
                staffName,

                departments,
                departmentId: primaryDepartment?.id || "",
                departmentName: primaryDepartment?.name || "",

                leaveType:
                  leaveEventData.leaveType || leaveEventData.type || "annual",

                dayValue: leaveEventData.dayValue || leaveEventData.value || 1,
              });
            });

            allTrackerEvents.push(...staffEvents);
            publishIfReady();
          },
          (err) => {
            onError?.(err);
            publishIfReady();
          },
        );

        eventUnsubscribes.push(unsubscribeLeaveEvents);
      });

      return () => {
        eventUnsubscribes.forEach((unsubscribe) => unsubscribe());
      };
    },
    (err) => {
      onError?.(err);
    },
  );

  return () => {
    staffUnsubscribe();
  };
};

const postStaffHolidayApi = async (path, payload = {}) => {
  const response = await fetch(
    `${STAFF_HOLIDAY_API_BASE_URL}/api/staff-holidays${path}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    },
  );

  const data = await response.json().catch(() => ({}));

  if (!response.ok || data.success === false) {
    throw new Error(
      data.message || `Staff holiday request failed: ${response.status}`,
    );
  }

  return data;
};

export const submitStaffHolidayRequest = async (payload) => {
  return postStaffHolidayApi("/request", payload);
};

export const updateStaffHolidayRequest = async ({
  staffEmail,
  requestId,

  leaveType,
  startDate,
  endDate,
  startDayType,
  endDayType,
  staffNotes,
  reason,

  status,
  updatedBy,
  updateReason = "",

  adminEdit = false,
  notifyStaff = true,
}) => {
  return postStaffHolidayApi("/update", {
    staffEmail,
    requestId,

    leaveType,
    startDate,
    endDate,
    startDayType,
    endDayType,
    staffNotes,
    reason,

    status,
    updatedBy,
    updateReason,

    adminEdit,
    notifyStaff,
  });
};

export const cancelStaffHolidayRequest = async ({
  staffEmail,
  requestId,
  cancelledBy,
  cancellationReason = "",
}) => {
  return postStaffHolidayApi("/cancel", {
    staffEmail,
    requestId,
    cancelledBy,
    cancellationReason,
  });
};

export const approveStaffHolidayAsHolidayManager = async ({
  staffEmail,
  requestId,
  holidayManagerEmail,
}) => {
  return postStaffHolidayApi("/holiday-manager-approve", {
    staffEmail,
    requestId,
    holidayManagerEmail,
  });
};

export const approveStaffHolidayAsAdmin = async ({
  staffEmail,
  requestId,
  adminEmail,
}) => {
  return postStaffHolidayApi("/admin-approve", {
    staffEmail,
    requestId,
    adminEmail,
  });
};

export const rejectStaffHolidayRequest = async ({
  staffEmail,
  requestId,
  rejectedBy,
  rejectionReason = "",
}) => {
  return postStaffHolidayApi("/reject", {
    staffEmail,
    requestId,
    rejectedBy,
    rejectionReason,
  });
};

// Backwards-compatible aliases
export const approveHolidayAsHolidayManager =
  approveStaffHolidayAsHolidayManager;
export const approveHolidayAsAdmin = approveStaffHolidayAsAdmin;

export const deleteStaffHolidayRequest = async ({
  staffEmail,
  requestId,
  deletedBy,
  deleteReason = "",
  notifyStaff = true,
}) => {
  return postStaffHolidayApi("/delete", {
    staffEmail,
    requestId,
    deletedBy,
    deleteReason,
    notifyStaff,
  });
};

export const fetchHolidayTrackerEventsForYear = async ({ year }) => {
  if (!year) return [];

  const selectedYear = String(year);
  const staffCollectionRef = collection(db, ...STAFF_ROOT_PATH);
  const staffSnapshot = await getDocs(staffCollectionRef);

  const allTrackerEvents = [];

  await Promise.all(
    staffSnapshot.docs.map(async (staffDoc) => {
      const staffEmail = normalizeEmail(staffDoc.id);
      const staffData = staffDoc.data() || {};
      const departments = normalizeDepartments(staffData.departments);
      const primaryDepartment = departments[0];

      const staffName = getStaffDisplayName(staffData, staffEmail);

      const leaveEventsRef = collection(
        db,
        ...STAFF_ROOT_PATH,
        staffDoc.id,
        "LeaveEvents",
      );

      const leaveEventsSnapshot = await getDocs(leaveEventsRef);

      leaveEventsSnapshot.docs.forEach((leaveEventDoc) => {
        const leaveEventData = leaveEventDoc.data() || {};

        const date = toDateKey(
          leaveEventData.date ||
            leaveEventData.leaveDate ||
            leaveEventData.startDate ||
            leaveEventDoc.id,
        );

        if (!isDateInYear(date, selectedYear)) {
          return;
        }

        allTrackerEvents.push({
          id: leaveEventDoc.id,
          ...leaveEventData,

          date,

          staffEmail,
          ownerStaffEmail: staffEmail,
          staffName: leaveEventData.staffName || staffName,

          departments,
          departmentId:
            leaveEventData.departmentId || primaryDepartment?.id || "",
          departmentName:
            leaveEventData.departmentName || primaryDepartment?.name || "",

          leaveType:
            leaveEventData.leaveType || leaveEventData.type || "annual_leave",

          dayValue: Number(
            leaveEventData.dayValue || leaveEventData.value || 1,
          ),
          status: leaveEventData.status || "approved",
        });
      });
    }),
  );

  return allTrackerEvents.sort((a, b) => {
    const dateCompare = String(a.date).localeCompare(String(b.date));

    if (dateCompare !== 0) return dateCompare;

    return String(a.staffName || "").localeCompare(String(b.staffName || ""));
  });
};
